import { render, staticRenderFns } from "./PreviewEmailContent.vue?vue&type=template&id=5a22c770&scoped=true"
import script from "./PreviewEmailContent.vue?vue&type=script&lang=js"
export * from "./PreviewEmailContent.vue?vue&type=script&lang=js"
import style0 from "./PreviewEmailContent.vue?vue&type=style&index=0&id=5a22c770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22c770",
  null
  
)

export default component.exports